import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import Typography from '@material-ui/core/Typography';
import { Slide } from '@material-ui/core';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  dialogModal: {
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
    },
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1.5),
    top: theme.spacing(0),
    color: theme.palette.custom.black,
    opacity: 0.2,
    paddingTop: '12px',
    '&:hover': {
      backgroundColor: 'unset',
      opacity: 0.5,
    },
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  button: {
    color: theme.palette.custom.white,
    borderRadius: '5px',
    margin: '15px 20px',
    fontWeight: 500,
    letterSpacing: 0.5,
    padding: '12px 15px',
    lineHeight: 1,
  },
  closeIcon: {
    fontSize: '21px',
    fontWeight: '700',
    lineHeight: 1,
    textShadow: `0 1px 0 ${theme.palette.custom.white}`,
    padding: '3px 0',
    '&:hover': {
      textDecoration: 'none',
      cursor: 'pointer',
    },
  },
  closeButtonContent: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: '25px',
    textTransform: 'none',
    '&:hover': {
      boxShadow: `0 0 0 2px ${theme.palette.primary.dark} inset`,
      color: theme.palette.custom.lightBlack,
      background: theme.palette.custom.white,
    },
    [theme.breakpoints.between('xs', 'md')]: {
      width: '100%',
    },
  },
  dialogTitle: {
    fontSize: '24px',
    lineHeight: 1.42,
    [theme.breakpoints.between('xs', 'md')]: {
      fontSize: '22px',
    },
  },
  paper: {
    margin: '10px',
    maxWidth: '100%',
    position: 'fixed',
    top: 0,
    [theme.breakpoints.down('md')]: {
      maxWidth: '340px',
    },
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h2" className={classes.dialogTitle}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          data-testid="security-code-close-button"
          onClick={onClose}
          disableRipple
          disableFocusRipple
          variant="text"
          size="small"
        >
          <CloseRoundedIcon className={classes.closeIcon} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogModal = withStyles(styles)((props) => {
  const { children, classes, onClose, handleClose, open, ...other } = props;
  return (
    <Dialog
      onClose={handleClose}
      TransitionComponent={Transition}
      aria-labelledby="subscription-dialog-title"
      classes={{ paper: classes.paper }}
      className={classes.dialogModal}
      open={open}
      maxWidth="lg"
      fullWidth
      {...other}
    >
      {children}
    </Dialog>
  );
});

const DialogButtonAction = withStyles(styles)((props) => {
  const { children, classes, handleClose, ...other } = props;
  return (
    <Button
      autoFocus
      fullWidth
      className={`${classes.button} ${classes.closeButtonContent}`}
      onClick={handleClose}
      {...other}
    >
      {children}
    </Button>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function CancellationConfirmationPopup({
  handleClose,
  open,
  dialogTitle,
  dialogContent,
  actionButtonCloseText,
}) {
  return (
    <div>
      <DialogModal handleClose={handleClose} open={open}>
        <DialogTitle
          id="subscription-dialog-title"
          style={{ padding: '24px', textTransform: 'uppercase' }}
        >
          {dialogTitle}
        </DialogTitle>
        <DialogContent
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="h5"
            style={{
              fontFamily: 'TitilliumWeb-Regular',
              margin: '0px 60px 42px 16px',
              fontWeight: 500,
              fontSize: '18px',
              lineHeight: '1.5',
            }}
          >
            {dialogContent}
          </Typography>
        </DialogContent>
        <DialogActions>
          <DialogButtonAction handleClose={handleClose}>
            {actionButtonCloseText}
          </DialogButtonAction>
        </DialogActions>
      </DialogModal>
    </div>
  );
}
